<template>
  <div class="wrapper">
    <el-container class="indexcontainer">
      <div class="banner" >
        <img src="../../image/logo/admin_banner.jpg" alt="" />
      </div>
    </el-container>
  </div>
</template>

<script>
import "../../assets/icons/iconfont.css";
import { toindex, getUserNavList } from "@/common/api.js";
import { TabView } from "../../components/TabView";
import { mapState } from "vuex";
import screenfull from "screenfull";

export default {
  components: {},
  props: {},
  data() {
    return {
     
    };
  },
  watch: {
   
  },
  computed: {
   
  },
  methods: {},
  created() {},
  mounted() {
   
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  /deep/.el-table__header .has-gutter th {
    background-color: #f5f5f6 !important;
    color: #676a6c;
    border-bottom: 1px solid #ccc;
  }
  /deep/.el-table__header .has-gutter th {
    background-color: #f5f5f6 !important;
    color: #676a6c;
    border-bottom: 1px solid #ccc;
  }
  /deep/.el-table__fixed-right .el-table__fixed-header-wrapper th {
    background-color: #f5f5f6 !important;
    color: #676a6c;
    border-bottom: 1px solid #ccc;
  }
  .el-main {
    overflow: hidden;
  }
  .indexcontainer {
    width: 100%;
    height: 100%;
    .el-header {
      position: fixed;
      z-index: 9;
      width: 100%;
      background-color: #4e97d9;
      height: 60px !important;
      padding: 0 !important;
      // line-height: 88px;
      img.admin-logo {
        width: 220px;
        height: 40px;
        margin-top: 10px;
        margin-left: 30px;
      }
      .headBox {
        height: 60px;
        width: 100%;
        line-height: 60px;
        .btn-fullscreen {
          float: right;
          .iconfont-s {
            margin-right: 10px;
            cursor: pointer;
          }
        }
        .right-menu {
          float: right;
          height: 100%;
          line-height: 60px;
        }
        .avatar-container {
          margin-right: 30px;
          .avatar-wrapper {
            position: relative;
            .user-avatar {
              cursor: pointer;
              width: 40px;
              height: 40px;
              margin-top: 10px;
              border-radius: 50%;
              vertical-align: top;
            }
            .user-name {
              float: right;
              margin-left: 10px;
              color: #ffffff;
              font-size: 14px;
              font-weight: 600;
            }
            .el-icon-caret-bottom {
              cursor: pointer;
              position: absolute;
              right: -20px;
              top: 35px;
              font-size: 16px;
            }
          }
        }
      }
    }
    .el-main {
      margin-left: 200px;
      margin-top: 60px;
      padding-top: 0;
      height: calc(100% - 60px);
    }
    .main_conainer {
      margin-left: 64px;
    }
    .el-aside {
      position: fixed;
      z-index: 9;
      height: calc(100% - 60px);
      margin-top: 60px;
      background-color: #333744;
      .toggle-button {
        background-color: #4a5064;
        font-size: 10px;
        line-height: 24px;
        color: #fff;
        text-align: center;
        letter-spacing: 0.2em;
        cursor: pointer;
      }
      .el-menu {
        border-right: none;
      }
      .navtages {
        height: 56px;
        max-width: 160px;
        line-height: 56px;
        color: #ffffff;
        padding: 0 20px;
        cursor: pointer;
        i {
          font-size: 18px;
          margin-right: 10px;
          color: #a7b1c2;
        }
        span {
          font-size: 14px;
        }
      }
    }
    .banner {
      width: 100%;
      text-align: center;
      img {
        width: 80%;
        margin-top: 10px;
      }
    }
    .iconfont {
      margin-right: 10px;
      font-size: 16px;
      color: #a7b1c2;
    }
    .screenicon {
      font-size: 24px;
      color: #fff;
    }
    .el-menu-item {
      color: #a7b1c2 !important;
    }
    .el-menu-item.is-active {
      color: #ffffff !important;
      background-color: #1890ff !important;
    }
    .el-submenu .el-menu-item {
      height: 36px !important;
      line-height: 36px !important;
    }
  }
  /deep/.cell .el-button--mini {
    padding: 2px 3px;
    margin-left: 5px;
  }
  /deep/.el-dialog__header {
    padding-top: 10px;
    background: #f8f8f8;
    border-bottom: 1px solid #ddd;
    .el-dialog__title {
      font-size: 16px;
    }
    .el-dialog__headerbtn {
      top: 10px;
    }
  }
  /deep/.el-dialog__footer {
    padding-bottom: 10px;
    background: #f8f8f8;
    border-top: 1px solid #ddd;
    .el-button {
      padding: 10px 15px;
    }
  }

  /* button color */
  /deep/.el-button--cyan.is-active,
  .el-button--cyan:active {
    background: #20b2aa;
    border-color: #20b2aa;
    color: #ffffff;
  }

  /deep/.el-button--cyan:focus,
  /deep/.el-button--cyan:hover {
    background: #48d1cc;
    border-color: #48d1cc;
    color: #ffffff;
  }

  /deep/.el-button--cyan {
    background-color: #20b2aa;
    border-color: #20b2aa;
    color: #ffffff;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/homeIndex.vue